import { OrganizationInfoWrapper } from "../../components";

export default function OrganizationInfoPage() {
  return (
    <>
      <OrganizationInfoWrapper />
    </>
  );
}
